/// <amd-module name="Search/Shared/Components/ExtendedSearchSection" />
export * from "./ExtendedSearchSection/index";
